import React from 'react';
import { AccountingStat } from '../accountingTypes';
import styles from './AccountingStatCard.module.css';

interface AccountingStatCardProps {
  stat: AccountingStat;
  icon: React.ReactNode;
}

export const AccountingStatCard: React.FC<AccountingStatCardProps> = ({ stat, icon }) => {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.iconWrapper} style={{ background: stat.iconBg }}>
          <span style={{ color: stat.iconColor }}>{icon}</span>
        </div>
        <span className={styles.label}>{stat.label}</span>
      </div>

      {stat.paymentModes ? (
        <div className={styles.paymentModes}>
          {stat.paymentModes.map((m) => (
            <div key={m.label} className={styles.paymentMode}>
              <span className={styles.modeValue}>{m.value}</span>
              <span className={styles.modeLabel}>{m.label}</span>
            </div>
          ))}
        </div>
      ) : (
        <>
          <p className={styles.value} style={stat.valueColor ? { color: stat.valueColor } : undefined}>
            {stat.value}
          </p>
          {stat.subtext && <p className={styles.subtext}>{stat.subtext}</p>}
        </>
      )}
    </div>
  );
};
